(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("react-dom"), require("module"));
	else if(typeof define === 'function' && define.amd)
		define("UU5", ["react", "react-dom", "module"], factory);
	else if(typeof exports === 'object')
		exports["UU5"] = factory(require("react"), require("react-dom"), require("module"));
	else
		root["UU5"] = factory(root["React"], root["ReactDOM"], root["undefined"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_25__, __WEBPACK_EXTERNAL_MODULE_42__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition